import { createReducer } from '@reduxjs/toolkit';
import { OrderGoodsItemDto } from '../../api/ClientApi';

import { addOrUpdateOrderGoodsItem, importApprovedOrderGoodsItems } from '../actions/orderGoodsItemsActions';

export interface OrderGoodsItemsState {
    approvedOrderGoodsItems: OrderGoodsItemDto[] | null;
}

export const orderGoodsItemsReducer = createReducer<OrderGoodsItemsState>(
    { approvedOrderGoodsItems: null },
    (builder) => {
        builder
            .addCase(addOrUpdateOrderGoodsItem, (state: OrderGoodsItemsState, action: any) => {
                const newOrderGoodItem = action.payload;

                const oldOrderGoodItemIndex = state.approvedOrderGoodsItems?.findIndex(
                    (o) => o.id === newOrderGoodItem.id,
                );

                if (oldOrderGoodItemIndex !== undefined && oldOrderGoodItemIndex >= 0) {
                    state.approvedOrderGoodsItems?.splice(oldOrderGoodItemIndex, 1, newOrderGoodItem);
                } else {
                    if (!state.approvedOrderGoodsItems) {
                        state.approvedOrderGoodsItems = [newOrderGoodItem];
                    } else {
                        state.approvedOrderGoodsItems.unshift(newOrderGoodItem);
                    }
                }
            })
            .addCase(importApprovedOrderGoodsItems.fulfilled, (state: OrderGoodsItemsState, action: any) => {
                const newOgi = (action.payload ?? []) as OrderGoodsItemDto[];

                state.approvedOrderGoodsItems = newOgi.sort((a, b) => (b.id ?? 0) - (a.id ?? 0));
            });
    },
);
